import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  endJobHeader: {
    id: 'towingRecord.end.endJobHeader',
    defaultMessage: 'Lopeta työ',
  },
  endJobButton: {
    id: 'towingRecord.end.endJobButton',
    defaultMessage: 'Lopeta työ',
  },
  cancelJobButton: {
    id: 'towingRecord.end.cancelJobButton',
    defaultMessage: 'Työ peruutettu',
  },
  cannotCancelModalLabel: {
    id: 'towingRecord.end.cannotCancelModalLabel',
    defaultMessage: 'Työtä ei voi peruuttaa',
  },
  cannotCancelModalMessage: {
    id: 'towingRecord.end.cannotCancelModalMessage',
    defaultMessage: 'Ennakkomaksu on jo maksettu maksulinkillä. Hyvitä maksu ensin, jotta voit peruuttaa työn.',
  },
  cannotCancelModalCloseLabel: {
    id: 'towingRecord.end.cannotCancelModalCloseLabel',
    defaultMessage: 'OK',
  },
  incompleteRouteWarning: {
    id: 'towingRecord.end.incompleteRouteWarning',
    defaultMessage: '{label} reittipisteeltä puuttuu tietoja',
  },
  finalizeRequiredWarning: {
    id: 'towingRecord.end.finalizeRequiredWarning',
    defaultMessage:
      'Huom! Paikan päällä suoritetussa työssä pitää olla kirjattu kohteen tiedot ja hinauksissa kohteen sekä määränpään tiedot ennen kuin työ voidaan merkitä valmiiksi',
  },
})
